var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MoneyFormat',{attrs:{"hide-subunits":_vm.subunits,"value":_vm.amount,"locale":"ru","currency-code":_vm.currency}})}
var staticRenderFns = []

export { render, staticRenderFns }